import { SectionFourDocTypeTypes } from "../types/documents-four-enum";

export const uploadConfigFour = [
  {
    title: "Нормативная документация",
    docType: SectionFourDocTypeTypes.REGULATION_DOC,
    optional: false,
    uploadMode: "modal",
  },
  {
    title: "Сопроводительные документы",
    docType: SectionFourDocTypeTypes.SUPPORTING_DOC,
    optional: true,
    uploadMode: "modal",
  },
  {
    title: "Проектная документация",
    docType: SectionFourDocTypeTypes.PROJECT_DOC,
    optional: true,
    uploadMode: "modal",
  },
  {
    title: "Рабочая документация",
    docType: SectionFourDocTypeTypes.WORK_DOC,
    optional: true,
    uploadMode: "modal",
  },
];

